import useAnswerTranslate from "FlowBuilder/hooks/useAnswerTranslate"
import useQuestionTranslate from "FlowBuilder/hooks/useQuestionTranslate"


export default function ResponsesConfirmation({ response, setResponse, label, disabled = false, className = '', question = {} }) {

  const answerablePrecedingQuestions = useSel(s => _.values(s.questions.entities).filter(
    q => q.surveyId === question.surveyId && q.active 
    && q.pageNumber <= question.pageNumber
    && q.questionType !== 'intro' && q.questionType !== 'instruction' && q.questionType !== 'responses_confirmation'))
  
  const { fallback: { responseConfirmMessage, noAnswerProvidedMessage } } = useQuestionTranslate({ questionOverride: question })

  return <div className={`answers grow ${className}`}>
    {answerablePrecedingQuestions.map(q => (
      <AnswerableQuestionConfirmation question={q} key={q.id} noAnswerProvidedMessage={noAnswerProvidedMessage} />
    ))}
    <label className="flex-center">
      <input type="checkbox" onChange={(e) => setResponse(e.target.checked ? 'y' : 'n')} disabled={disabled} checked={response === 'y'} />
      {responseConfirmMessage}
    </label>
    </div>
}

function AnswerableQuestionConfirmation({ question, noAnswerProvidedMessage }) {
  const responses = useSel(s => s.taker?.submittedResponses || {})

  const { fallback: { name: questionText, yesLabel, noLabel } } = useQuestionTranslate({ questionOverride: question })

  const getAnswerText = (response, question) => {
    if (!response && question.questionType != 'checkbox') return <AnswerableQuestionTextAnswer noAnswerText={noAnswerProvidedMessage} />
    if (question.questionType === 'opt_in_radio') {
      return response.answerText === 'y' ? <AnswerableQuestionTextAnswer text={yesLabel} /> : <AnswerableQuestionTextAnswer text={noLabel} />
    }
    if (question.questionType === 'checkbox') {
      return response && response.answerText === 'y' ? <input type="checkbox" checked disabled key={question.id + '-yes'} /> : <input type="checkbox" disabled key={question.id + '-no'}/>
    }
    const answers = _.filter(question.answers, a => response.answerIds?.includes(a.id) || response.answerId === a.id)
    if (question.questionType === 'multiple_choice' && answers.length) {
      return <AnswerableQuestionAnswerConfirmation question={question} answer={answers[0]} />
    }
    if (question.questionType === 'multiple_select' && answers.length) {
      return answers.map(a => <AnswerableQuestionAnswerConfirmation key={a.id} question={question} answer={a} />)
    }
    if (question.questionType === 'score' && response.answerNumeric) {
      return <AnswerableQuestionTextAnswer text={response.answerNumeric} />
    }
    if (response.answerText) {
      return <AnswerableQuestionTextAnswer text={response.answerText} />
    }
    return <AnswerableQuestionTextAnswer noAnswerText={noAnswerProvidedMessage}/>
  }

  const response = getAnswerText(_.find(responses, r => r.questionId === question.id), question)

  return <div className={`submitted-response-question-type-${question.questionType}`}>
        <label className="submitted-response-question">{questionText}</label>
        <div className="submitted-response">
          {response}
        </div>
      </div>
}

function AnswerableQuestionAnswerConfirmation({ question, answer }) {
  const { fallback: { answer: answerText } } = useAnswerTranslate({ answerOverride: answer })

  return <AnswerableQuestionTextAnswer text={answerText} />
}

function AnswerableQuestionTextAnswer({ text = null, noAnswerText = 'No answer provided' }) {
  if(!text) {
    return <span className="submitted-response-answer no-response">{noAnswerText}</span>
  }

  return <span className="submitted-response-answer">{ text }</span>
}